<style scoped src="../../../gallery/gallery/gallery.scss" lang="scss"></style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import axios from "axios";

export default {
  mixins: [defaultGallery],
  
  computed: {
    cityName: {
      cache: false,
      get() {
        const cityName = /^#город_([А-я_-]+)/.exec(
          decodeURIComponent(window.location.hash)
        );

        return (cityName && cityName[1]) || "";
      },
    },
  },

  methods: {
    loadMoreCallback(url) {
      const { cityName } = this;

      return cityName ? `${url}&lancome_city_name=${cityName}` : url;
    },

    getCityPosts() {
      const { settings, cityName, postList } = this;

      axios
        .get(`${settings.sourceUrl}&lancome_city_name=${cityName}`)
        .then((response) => {
          postList.splice(0, postList.length, ...response.data.posts);

          if (response.data.lastPage) {
            settings.hasMore = false;
          } else {
            settings.hasMore = true;
            this.$nextTick(this.onScroll);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },

  created() {
    const { cityName, getCityPosts } = this;

    if (cityName) {
      getCityPosts();
    }

    window.addEventListener("hashchange", getCityPosts);
  },
}
</script>
